import React, { useState } from 'react';
import { Authenticator } from 'aws-amplify-react';
import logo from '../../logo.png';
import { Grid, Checkbox, Segment, Image } from 'semantic-ui-react';
import { Auth } from 'aws-amplify';
import IdleTimer from 'react-idle-timer';
import authStorage from '../../AuthenticationStorage';
import SignUpConfig from './SignUpConfig';
import styles from './Authenticator.style.module.css';

const AgeReadyAuthenticator: React.FC<any> = (props) => {
  const signedIn = 'signedIn';
  const [rememberMe, setRememberMe] = useState(
    localStorage.getItem('remember-me') === 'true'
  );
  const [authState, setAuthState] = useState('');

  const onIdle = () => {
    if (!rememberMe) {
      Auth.signOut();
    }
  };

  const onRememberMeChange = (_: any, data: any) => {
    setRememberMe(data.checked);

    authStorage.setRememberMe(data.checked);
    localStorage.setItem('remember-me', data.checked);
  };

  const authStateChange = (authState: string) => {
    setAuthState(authState);
  };

  const rememberMeCheckbox = () => {
    return (
      <div
      className={styles['remember-check']}
        style={{
          position: 'absolute',
          zIndex: 2,
          top: '292px',
          left: '14px',
          display: 'inline-block',
          color: '#828282',
          fontSize: '13px',
        }}
      >
        <Checkbox
          label={
            <label
              style={{
                color: '#828282',
                fontSize: '13px',
                fontFamily: '"Helvetica Neue", sans-serif',
              }}
            >
              Remember me
            </label>
          }
          onChange={onRememberMeChange}
          checked={rememberMe}
          data-testid='remember me'
          style={{
            color: '#828282',
            fontSize: '12px',
            fontFamily: '"Helvetica Neue", sans-serif',
          }}
          color={'#828282'}
        />
      </div>
    );
  };

  if (authState !== signedIn) {
    const imageStyle = { maxWidth: '300px', width: '100%', margin: 'auto', display: 'flex' };
    const authProps = { ...props };
    delete authProps.children;
    return (
      <div
        style={{
          display: 'flex',
          minHeight: '100vh',
          padding: '15px'
        }}
      >
        <div
          style={{
            backgroundColor: 'rgba(255,255,255)',
            maxWidth: '400px',
            width: '100%',
            borderRadius: 15,
            margin: 'auto',
          }}
        >
          <Grid padded columns={1} className={styles['login-and-register']}>
            <Grid.Column textAlign='center'>
              <Segment basic  className={styles['main-logo']}>
                <Image
                  size='medium'
                  src={logo}
                  alt='age-ready-logo'
                  style={imageStyle}
                />
              </Segment>
              {authState === 'signIn' ? rememberMeCheckbox() : null}
              <Authenticator
                theme={{
                  formContainer: {
                    minWidth: 375,
                  },
                }}
                {...authProps}
                onStateChange={authStateChange}
                signUpConfig={SignUpConfig}
              />
              <a style={{ color: "rgb(0, 52, 104)", textDecoration: "underline" }} href="https://beageready.com/terms-of-use/" target="_blank" rel="noreferrer">Terms of Use</a>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <IdleTimer onIdle={onIdle} timeout={1000 * 60 * 30} startOnMount />
        {props.children}
      </div>
    );
  }
};

export default AgeReadyAuthenticator;
